var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("q-page", { staticClass: "flex flex-center" }, [
    _vm.message
      ? _c(
          "div",
          { staticStyle: { "margin-bottom": "20px" } },
          [
            _c(
              "q-alert",
              {
                attrs: {
                  color: "blue-4",
                  icon: "info",
                  enter: "fadeIn",
                  leave: "fadeOut",
                  appear: "",
                  dismissible: ""
                }
              },
              [
                _c("b", [_vm._v("Logged out: ")]),
                _vm._v(" " + _vm._s(_vm.message) + "\n    ")
              ]
            )
          ],
          1
        )
      : _vm._e(),
    _c(
      "form",
      {
        on: {
          submit: function($event) {
            $event.preventDefault()
            return _vm.handleResetPasswordForm.apply(null, arguments)
          }
        }
      },
      [
        _c(
          "q-card",
          { staticClass: "mdi-card relative-position" },
          [
            _c("q-card-title", { staticClass: "bg-secondary text-white" }, [
              _vm._v("\n        Reset Password\n      ")
            ]),
            _c("q-card-separator"),
            _c(
              "q-card-main",
              { staticClass: "q-pa-md" },
              [
                _c(
                  "q-field",
                  {
                    attrs: {
                      icon: "mail",
                      label: "Email",
                      orientation: "vertical",
                      helper:
                        "please type in your email address to reset your password"
                    }
                  },
                  [
                    _c("q-input", {
                      attrs: { type: "email", autofocus: "" },
                      model: {
                        value: _vm.email,
                        callback: function($$v) {
                          _vm.email = $$v
                        },
                        expression: "email"
                      }
                    })
                  ],
                  1
                ),
                _c("br"),
                !_vm.resetToken
                  ? _c(
                      "q-field",
                      {
                        attrs: {
                          label: "Reset Code",
                          icon: "code",
                          orientation: "vertical",
                          helper: "The token from your email"
                        }
                      },
                      [
                        _c("q-input", {
                          model: {
                            value: _vm.resetToken,
                            callback: function($$v) {
                              _vm.resetToken = $$v
                            },
                            expression: "resetToken"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _c("br"),
                _c(
                  "q-field",
                  {
                    attrs: {
                      icon: "lock",
                      label: "New Password",
                      orientation: "vertical",
                      helper: "provide a new password"
                    }
                  },
                  [
                    _c("q-input", {
                      attrs: { type: "password" },
                      model: {
                        value: _vm.password,
                        callback: function($$v) {
                          _vm.password = $$v
                        },
                        expression: "password"
                      }
                    })
                  ],
                  1
                ),
                _c("br"),
                _c(
                  "q-field",
                  {
                    attrs: {
                      orientation: "vertical",
                      label: "Confirm New Password",
                      icon:
                        _vm.password &&
                        _vm.passwordConfirmation === _vm.password
                          ? "check"
                          : "lock"
                    }
                  },
                  [
                    _c("q-input", {
                      attrs: { type: "password" },
                      model: {
                        value: _vm.passwordConfirmation,
                        callback: function($$v) {
                          _vm.passwordConfirmation = $$v
                        },
                        expression: "passwordConfirmation"
                      }
                    })
                  ],
                  1
                ),
                _vm.error
                  ? _c(
                      "div",
                      { staticClass: "q-ma-lg q-pa-lg" },
                      [
                        _c(
                          "q-alert",
                          {
                            attrs: {
                              color: "negative",
                              icon: "error",
                              enter: "fadeIn",
                              leave: "fadeOut",
                              appear: "",
                              dismissible: ""
                            }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.error) +
                                "\n          "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            ),
            _c(
              "q-card-actions",
              [
                _c(
                  "q-btn",
                  {
                    staticClass: "full-width no-shadow",
                    attrs: {
                      loader: "",
                      large: "",
                      color: "primary",
                      icon: "lock",
                      type: "submit",
                      label: "Reset Password",
                      disabled: !_vm.canSubmit || _vm.loading
                    },
                    model: {
                      value: _vm.loading,
                      callback: function($$v) {
                        _vm.loading = $$v
                      },
                      expression: "loading"
                    }
                  },
                  [
                    _c(
                      "span",
                      { attrs: { slot: "loading" }, slot: "loading" },
                      [
                        _c("q-spinner", { staticClass: "on-left" }),
                        _vm._v("\n              Resetting ...\n            ")
                      ],
                      1
                    )
                  ]
                )
              ],
              1
            ),
            _c("q-inner-loading", { attrs: { visible: _vm.loading } })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }